module.exports = __webpack_public_path__ + "static/media/gal2.832faee9.jpg";